/**
 * @license
 * Copyright 2012 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Generating Arduino for logic blocks.
 */
'use strict';

goog.module('Blockly.Arduino.logic');

const { arduinoGenerator: Arduino } = goog.require('Blockly.Arduino');


/**
 * Code generator to create if/if else/else statement.
 * Arduino code: loop { if (X)/else if ()/else { X } }
 * @param {!Block} block Block to generate the code from.
 * @return {string} Completed code.
 */
Arduino['controls_if'] = function (block) {
  var n = 0;
  var argument = Arduino.valueToCode(block, 'IF' + n,
    Arduino.ORDER_NONE) || 'false';
  var branch = Arduino.statementToCode(block, 'DO' + n);
  var code = 'if (' + argument + ') {\n' + branch + '}';
  for (n = 1; n <= block.elseifCount_; n++) {
    argument = Arduino.valueToCode(block, 'IF' + n,
      Arduino.ORDER_NONE) || 'false';
    branch = Arduino.statementToCode(block, 'DO' + n);
    code += ' else if (' + argument + ') {\n' + branch + '}';
  }
  if (block.elseCount_) {
    branch = Arduino.statementToCode(block, 'ELSE');
    code += ' else {\n' + branch + '}';
  }
  return code + '\n';
};

/**
 * Code generator for the comparison operator block.
 * Arduino code: loop { X operator Y }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 */
Arduino['logic_compare'] = function (block) {
  var OPERATORS = {
    'EQ': '==',
    'NEQ': '!=',
    'LT': '<',
    'LTE': '<=',
    'GT': '>',
    'GTE': '>='
  };
  var operator = OPERATORS[block.getFieldValue('OP')];
  var order = (operator == '==' || operator == '!=') ?
    Arduino.ORDER_EQUALITY : Arduino.ORDER_RELATIONAL;
  var argument0 = Arduino.valueToCode(block, 'A', order) || '0';
  var argument1 = Arduino.valueToCode(block, 'B', order) || '0';
  var code = argument0 + ' ' + operator + ' ' + argument1;
  return [code, order];
};

/**
 * Code generator for the logic operator block.
 * Arduino code: loop { X operator Y }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 */
Arduino['logic_operation'] = function (block) {
  var operator = (block.getFieldValue('OP') == 'AND') ? '&&' : '||';
  var order = (operator == '&&') ? Arduino.ORDER_LOGICAL_AND :
    Arduino.ORDER_LOGICAL_OR;
  var argument0 = Arduino.valueToCode(block, 'A', order) || 'false';
  var argument1 = Arduino.valueToCode(block, 'B', order) || 'false';
  if (!argument0 && !argument1) {
    // If there are no arguments, then the return value is false.
    argument0 = 'false';
    argument1 = 'false';
  } else {
    // Single missing arguments have no effect on the return value.
    var defaultArgument = (operator == '&&') ? 'true' : 'false';
    if (!argument0) {
      argument0 = defaultArgument;
    }
    if (!argument1) {
      argument1 = defaultArgument;
    }
  }
  var code = argument0 + ' ' + operator + ' ' + argument1;
  return [code, order];
};

/**
 * Code generator for the logic negate operator.
 * Arduino code: loop { !X }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 */
Arduino['logic_negate'] = function (block) {
  var order = Arduino.ORDER_UNARY_PREFIX;
  var argument0 = Arduino.valueToCode(block, 'BOOL', order) || 'false';
  var code = '!' + argument0;
  return [code, order];
};

/**
 * Code generator for the boolean values true and false.
 * Arduino code: loop { true/false }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 */
Arduino['logic_boolean'] = function (block) {
  var code = (block.getFieldValue('BOOL') == 'TRUE') ? 'true' : 'false';
  return [code, Arduino.ORDER_ATOMIC];
};

/**
 * Code generator for the null value.
 * Arduino code: loop { X ? Y : Z }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 */
Arduino['logic_null'] = function (block) {
  var code = 'NULL';
  return [code, Arduino.ORDER_ATOMIC];
};

/**
 * Code generator for the ternary operator.
 * Arduino code: loop { NULL }
 * @param {!Block} block Block to generate the code from.
 * @return {array} Completed code with order of operation.
 *
 * TODO: Check types of THEN and ELSE blocks and add warning to this block if
 *       they are different from each other.
 */
Arduino['logic_ternary'] = function (block) {
  var valueIf = Arduino.valueToCode(block, 'IF',
    Arduino.ORDER_CONDITIONAL) || 'false';
  var valueThen = Arduino.valueToCode(block, 'THEN',
    Arduino.ORDER_CONDITIONAL) || 'null';
  var valueElse = Arduino.valueToCode(block, 'ELSE',
    Arduino.ORDER_CONDITIONAL) || 'null';
  var code = valueIf + ' ? ' + valueThen + ' : ' + valueElse;
  return [code, Arduino.ORDER_CONDITIONAL];
};
